/** 
 * dom module
 * @module dom:tes
 */

 /**
 * @constructor
 * @alias module:dom:tes
 */
window['dom:tes'] = (function(document, $, Modernizr) {

    var elementsCache = {};

    function get(selector) {
        var elements = elementsCache[selector];
        if (elements) return $(elements);
        else {
            return elementsCache[selector] = $(selector);
        }
    }

    return {
        /** get by selector */
        get : get,
        /** browser features */
        features : Modernizr
    }

}(document, jQuery, Modernizr));